import { ITransferMethodDictionaryApi } from '@/types/dictionary';

export class TransferMethodDictionaryItem {
    id: number;
    name: string;

    constructor(data: ITransferMethodDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
    }
}
